"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const access_1 = require("@completeanatomy/access");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
const ChangeDiversity_1 = require("../../atoms/ChangeDiversity");
const constants_1 = require("../../constants");
const hooks_1 = require("../../hooks");
const SystemsIcons = {
    [constants_1.SystemIdentifier.Skeletal]: ui_1.Icons.Skeletal,
    [constants_1.SystemIdentifier.ConnectiveT]: ui_1.Icons.Connective_T,
    [constants_1.SystemIdentifier.Muscular]: ui_1.Icons.Muscular,
    [constants_1.SystemIdentifier.Arterial]: ui_1.Icons.Arterial,
    [constants_1.SystemIdentifier.Venous]: ui_1.Icons.Venous,
    [constants_1.SystemIdentifier.Lymphatic]: ui_1.Icons.Lymphatic,
    [constants_1.SystemIdentifier.Nervous]: ui_1.Icons.Nervous,
    [constants_1.SystemIdentifier.Respiratory]: ui_1.Icons.Respiratory,
    [constants_1.SystemIdentifier.Digestive]: ui_1.Icons.Digestive,
    [constants_1.SystemIdentifier.Endocrine]: ui_1.Icons.Endocrine,
    [constants_1.SystemIdentifier.Urogenital]: ui_1.Icons.Urogenital,
    [constants_1.SystemIdentifier.Integumentary]: ui_1.Icons.Integumentary,
};
/**
 * @visibleName SystemsMenuButton
 */
// eslint-disable-next-line max-lines-per-function
function SystemsMenuButton({ identifier, subtitle, title, isPlusButtonActive, isResetButtonActive, isActive, isDisabled, openedControls, onOpenAccessPopup, style, onToggleControls, onEvent, activeLayerIndex, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [performingClick, setPerformingClick] = (0, react_1.useState)(false);
    const [performingPlus, setPerformingPlus] = (0, react_1.useState)(false);
    const [performingMinus, setPerformingMinus] = (0, react_1.useState)(false);
    const [performingReset, setPerformingReset] = (0, react_1.useState)(false);
    const isChangeDiversityActive = identifier === constants_1.SystemIdentifier.Integumentary;
    const isButtonAvailableOffline = (0, hooks_1.useIsButtonAvailableOffline)(identifier);
    const [controlsStyle, setControlsStyle] = (0, react_1.useState)({});
    const hasAccess = (0, access_1.useAccessCheck)(bridge_schema_1.UIAccessModifier.Restricted, bridge_schema_1.AccessLevel.Upgraded);
    const { isMobile } = (0, device_1.usePlatform)();
    const buttonRef = (0, react_1.useRef)(null);
    const showOfflineSnackbar = () => {
        var _a, _b;
        /**
         * @todo show snackbar from modules
         */
        // @ts-ignore
        (_b = (_a = window.Manager) === null || _a === void 0 ? void 0 : _a.Snackbar) === null || _b === void 0 ? void 0 : _b.showOfflineSnackbar(t('snackbar.offlineSystem'), null);
        return;
    };
    const checkIsAccess = (0, react_1.useCallback)(() => {
        if (identifier === constants_1.SystemIdentifier.Skeletal ||
            identifier === constants_1.SystemIdentifier.ConnectiveT) {
            return true;
        }
        return hasAccess;
    }, [hasAccess, identifier]);
    const onEventHandler = (0, react_1.useCallback)((type) => {
        if (isDisabled) {
            return;
        }
        if (!checkIsAccess()) {
            if (ui_1.ActionType.SINGLE_CLICK === type || ui_1.ActionType.LONG_CLICK === type)
                onOpenAccessPopup();
            return;
        }
        switch (type) {
            case ui_1.ActionType.MOUSE_DOWN:
                setPerformingClick(true);
                break;
            case ui_1.ActionType.SINGLE_CLICK:
                if (!isButtonAvailableOffline) {
                    showOfflineSnackbar();
                    return;
                }
                onToggleControls(identifier);
                break;
            case ui_1.ActionType.LONG_CLICK:
                if (!isButtonAvailableOffline) {
                    showOfflineSnackbar();
                    return;
                }
                onEvent(identifier, bridge_schema_1.SystemsMenuAction.Simple);
                break;
            case ui_1.ActionType.MOUSE_UP:
                setPerformingClick(false);
                break;
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isDisabled,
        checkIsAccess,
        isButtonAvailableOffline,
        onToggleControls,
        identifier,
        onEvent,
    ]);
    const onPlusEvent = (0, react_1.useCallback)((type) => {
        if (!isPlusButtonActive) {
            return;
        }
        /**
         * @todo think how to fix activeLayerIndex
         */
        if (!hasAccess && identifier === constants_1.SystemIdentifier.Skeletal) {
            const shouldShowPopup = type === ui_1.ActionType.LONG_CLICK ||
                (type === ui_1.ActionType.SINGLE_CLICK && activeLayerIndex + 1 > 0);
            if (shouldShowPopup) {
                onOpenAccessPopup();
                return;
            }
        }
        switch (type) {
            case ui_1.ActionType.MOUSE_DOWN:
                setPerformingPlus(true);
                break;
            case ui_1.ActionType.SINGLE_CLICK:
            case ui_1.ActionType.DOUBLE_CLICK:
                onEvent(identifier, bridge_schema_1.SystemsMenuAction.Plus);
                break;
            case ui_1.ActionType.LONG_CLICK:
                onEvent(identifier, bridge_schema_1.SystemsMenuAction.LongPlus);
                break;
            case ui_1.ActionType.MOUSE_UP:
                setPerformingPlus(false);
                break;
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [identifier, isPlusButtonActive, onEvent, activeLayerIndex, hasAccess]);
    const onMinusEvent = (0, react_1.useCallback)((type) => {
        if (!isActive) {
            return;
        }
        switch (type) {
            case ui_1.ActionType.MOUSE_DOWN:
                setPerformingMinus(true);
                break;
            case ui_1.ActionType.SINGLE_CLICK:
            case ui_1.ActionType.DOUBLE_CLICK:
                onEvent(identifier, bridge_schema_1.SystemsMenuAction.Minus);
                break;
            case ui_1.ActionType.LONG_CLICK:
                onEvent(identifier, bridge_schema_1.SystemsMenuAction.LongMinus);
                break;
            case ui_1.ActionType.MOUSE_UP:
                setPerformingMinus(false);
                break;
        }
    }, [identifier, isActive, onEvent]);
    const onResetEvent = (0, react_1.useCallback)((type) => {
        if (!isResetButtonActive) {
            return;
        }
        switch (type) {
            case ui_1.ActionType.MOUSE_DOWN:
                setPerformingReset(true);
                break;
            case ui_1.ActionType.SINGLE_CLICK:
            case ui_1.ActionType.DOUBLE_CLICK:
            case ui_1.ActionType.LONG_CLICK:
                onEvent(identifier, bridge_schema_1.SystemsMenuAction.Reset);
                break;
            case ui_1.ActionType.MOUSE_UP:
                setPerformingReset(false);
                break;
        }
    }, [identifier, isResetButtonActive, onEvent]);
    const updateControlStyle = () => {
        if (buttonRef.current) {
            const { left, width } = buttonRef.current
                ? buttonRef.current.getBoundingClientRect()
                : { width: 0, left: 0 };
            setControlsStyle({
                width,
                left,
            });
        }
    };
    (0, react_1.useEffect)(() => {
        updateControlStyle();
        window.addEventListener('resize', updateControlStyle);
        return () => {
            window.removeEventListener('resize', updateControlStyle);
        };
    }, [subtitle, openedControls]);
    const [buttonHandlers] = (0, ui_1.useLongPressHandlers)(onEventHandler);
    const [plusHandlers] = (0, ui_1.useLongPressHandlers)(onPlusEvent);
    const [minusHandlers] = (0, ui_1.useLongPressHandlers)(onMinusEvent);
    const [resetHandlers] = (0, ui_1.useLongPressHandlers)(onResetEvent);
    const renderControls = () => {
        return ((0, jsx_runtime_1.jsxs)(Controls, { style: controlsStyle, "data-e2e": 'SystemsMenuButton_Controls', children: [isChangeDiversityActive && ((0, jsx_runtime_1.jsx)(ButtonContainer, { "data-e2e": 'SystemsMenuButton_ButtonContainer', children: (0, jsx_runtime_1.jsx)(ChangeDiversity_1.ChangeDiversity, { "data-e2e": 'SystemsMenuButton_ChangeDiversity' }) })), (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isResetButtonActive, timeout: 200, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'SystemsMenuButton_CSSTransition', children: (0, jsx_runtime_1.jsxs)(ButtonContainer, Object.assign({}, resetHandlers, { "data-testid": "system-reset-button", "$performingMouseDown": performingReset, "data-e2e": 'SystemsMenuButton_ButtonContainer', children: [(0, jsx_runtime_1.jsx)(ui_1.ResetButton, { width: 21, height: 21, onClick: () => { }, "data-e2e": 'SystemsMenuButton_ResetButton' }), (0, jsx_runtime_1.jsx)(ResetButtonLabel, { "data-e2e": 'SystemsMenuButton_ResetButtonLabel', children: (0, i18n_1.Localized)(i18n_1.Strings.common.showHiddenBreak) })] })) }), (0, jsx_runtime_1.jsx)(ButtonContainer, Object.assign({ "$active": isPlusButtonActive }, plusHandlers, { "data-testid": "system-plus-button", "$performingMouseDown": performingPlus, "data-e2e": 'SystemsMenuButton_ButtonContainer', children: (0, jsx_runtime_1.jsx)(ControlButton, { name: ui_1.Icons.Circle_Plus, height: 50, "$active": isPlusButtonActive, selected: performingPlus, "data-e2e": 'SystemsMenuButton_ControlButton' }) })), (0, jsx_runtime_1.jsx)(ButtonContainer, Object.assign({ "$active": isActive }, minusHandlers, { "data-testid": "system-minus-button", "$performingMouseDown": performingMinus, "data-e2e": 'SystemsMenuButton_ButtonContainer', children: (0, jsx_runtime_1.jsx)(ControlButton, { name: ui_1.Icons.Minus, height: 50, "$active": isActive, selected: performingMinus, "data-e2e": 'SystemsMenuButton_ControlButton' }) }))] }));
    };
    const icon = SystemsIcons[identifier] || ui_1.Icons.Microscope;
    return ((0, jsx_runtime_1.jsxs)(Container, { ref: buttonRef, style: style, "data-e2e": 'SystemsMenuButton_Container', children: [(0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: openedControls === identifier, timeout: 300, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'SystemsMenuButton_CSSTransition', children: renderControls() }), (0, jsx_runtime_1.jsxs)(ButtonContainer, Object.assign({ "data-testid": `${title}-button`, "$active": !isDisabled, "$disabled": !checkIsAccess() || !!isDisabled || !isButtonAvailableOffline, "$performingMouseDown": performingClick }, buttonHandlers, { "data-e2e": 'SystemsMenuButton_ButtonContainer', children: [(0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isResetButtonActive, timeout: 200, mountOnEnter: true, unmountOnExit: true, appear: true, "data-e2e": 'SystemsMenuButton_CSSTransition', children: (0, jsx_runtime_1.jsx)(ResetIcon, { width: 12, height: 12, onClick: () => { }, "data-e2e": 'SystemsMenuButton_ResetIcon' }) }), (0, jsx_runtime_1.jsx)(SystemIcon, { name: icon, selected: isActive, "$disabled": !!isDisabled, width: 40, height: 40, "data-e2e": 'SystemsMenuButton_SystemIcon' }), !isMobile && (0, jsx_runtime_1.jsx)(Status, { "$active": isActive, "data-e2e": 'SystemsMenuButton_Status', children: subtitle }), (0, jsx_runtime_1.jsx)(Title, { "$active": isActive, "data-e2e": 'SystemsMenuButton_Title', children: title })] }))] }));
}
exports.default = SystemsMenuButton;
const Container = styled_components_1.default.div `
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  box-sizing: border-box;
  min-width: 85px;
  height: 100%;
  padding-top: 7px;
  margin: 0 auto 0;

  text-align: center;

  user-select: none;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    justify-content: flex-end;
    box-sizing: content-box;

    min-width: 44px;
  `)};

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    min-width: 60px;
  `)};
`;
const Controls = styled_components_1.default.div `
  position: absolute;
  bottom: -21px;
  left: 0;
  padding-top: 10px;

  box-sizing: border-box;
  width: 100%;
  padding-bottom: 105px;

  background: ${({ theme }) => theme.primary};

  border: 1px solid ${({ theme }) => theme.secondary};
  border-radius: 10px 10px 0 0;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    padding-top: 10px;
    padding-bottom: 91px;
  `)};

  &.enter {
    transform: translateY(100%);
  }

  &.enter-active {
    transform: translateY(0);

    transition: transform 300ms cubic-bezier(0.2, 0, 0, 1.4);
  }

  &.exit {
    transform: translateY(0);
  }

  &.exit-active {
    transform: translateY(100%);

    transition: transform 300ms cubic-bezier(1, -0.4, 0.8, 1);
  }
`;
const Title = (0, ui_1.withFakeBold)(styled_components_1.default.div `
    position: relative;

    margin-bottom: 3px;
    padding: 0 2px;

    color: ${({ theme, $active }) => ($active ? theme.text : theme.disabled)};
    font-weight: ${({ $active }) => ($active ? 600 : 400)};

    font-size: 13px;
    line-height: 1em;
    white-space: nowrap;
    text-align: center;

    ${ui_1.device.tablet((0, styled_components_1.css) `
      font-size: 11px;
    `)};
  `);
const Status = styled_components_1.default.div `
  position: relative;

  padding: 0 4px;

  color: ${({ theme, $active }) => ($active ? theme.text : theme.disabled)};
  font-weight: 200;
  font-size: 11px;
  line-height: 1em;
`;
const ButtonContainer = styled_components_1.default.div `
  transform: scale(
    ${({ $performingMouseDown }) => ($performingMouseDown ? 0.9 : 1)}
  );
  cursor: ${({ $active }) => ($active ? 'pointer' : 'initial')};
  opacity: ${({ $disabled }) => ($disabled ? 0.2 : 1)};

  transition: transform 0.125s ease-in-out, opacity 0.2s ease-in-out;

  &.enter {
    opacity: 0;
  }

  &.enter-active {
    opacity: 1;
  }

  &.enter-done {
    opacity: 1;
  }

  &.exit {
    opacity: 1;
  }

  &.exit-active {
    opacity: 0;
  }

  &.exit-done {
    opacity: 0;
  }
`;
const ResetIcon = (0, styled_components_1.default)(ui_1.ResetButton) `
  width: 17px;
  height: 17px;
  position: absolute;
  left: 50%;

  margin-left: 8px;
  padding: 3px;

  &.enter,
  &.appear {
    opacity: 0;
  }

  &.enter-active,
  &.appear-active {
    opacity: 1;
    transition: opacity 0.2s ease-in-out;
  }

  &.enter-done,
  &.appear-done {
    opacity: 1;
  }

  &.exit {
    opacity: 1;
  }

  &.exit-active {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  &.exit-done {
    opacity: 0;
  }
`;
const ResetButtonLabel = styled_components_1.default.div `
  padding: 4px 0 6px;

  font-size: 10px;
`;
const SystemIcon = (0, styled_components_1.default)(ui_1.Icon) `
  position: relative;

  color: ${({ theme, $disabled, selected }) => $disabled ? theme.disabled : selected ? theme.text : theme.textSecondary};
`;
const ControlButton = (0, styled_components_1.default)(ui_1.Icon) `
  width: 100%;

  color: ${({ theme, $active }) => $active ? theme.text : theme.textSecondary};
`;
